/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Csv_To_Json_Faq_A7Inputs */

const en_csv_to_json_faq_a7 = /** @type {(inputs: Csv_To_Json_Faq_A7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Both map to the same object key and the rightmost one wins, because a JSON object cannot hold duplicate keys. No warning is shown, so rename the columns in the source file before converting.`)
};

const ko_csv_to_json_faq_a7 = /** @type {(inputs: Csv_To_Json_Faq_A7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`둘 다 같은 객체 키로 대응되고 가장 오른쪽 것이 이깁니다. JSON 객체는 중복 키를 담을 수 없기 때문입니다. 경고가 표시되지 않으므로 변환 전에 원본 파일에서 열 이름을 바꾸세요.`)
};

const ja_csv_to_json_faq_a7 = /** @type {(inputs: Csv_To_Json_Faq_A7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`両方が同じオブジェクトキーに対応し、最も右のものが勝ちます。JSON のオブジェクトは重複キーを持てないからです。警告は表示されないので、変換前に元ファイルで列名を変えてください。`)
};

/**
* | output |
* | --- |
* | "Both map to the same object key and the rightmost one wins, because a JSON object cannot hold duplicate keys. No warning is shown, so rename the columns in t..." |
*
* @param {Csv_To_Json_Faq_A7Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const csv_to_json_faq_a7 = /** @type {((inputs?: Csv_To_Json_Faq_A7Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Csv_To_Json_Faq_A7Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_csv_to_json_faq_a7(inputs)
	if (locale === "ko") return ko_csv_to_json_faq_a7(inputs)
	return ja_csv_to_json_faq_a7(inputs)
});